import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { IconName } from "lucide-react/dynamic";
import { Suspense } from "react";
import { NavigationTabs } from "@/components/navigation-tabs";
import { Page } from "@/components/page";
import { SheetSkeleton } from "@/components/skeletons/sheet-skeleton";
import { env } from "../../../../env";

export const Route = createFileRoute("/_authed/_org/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page
      heading="Settings"
      tabs={
        <NavigationTabs
          tabs={[
            {
              icon: "user",
              label: "Profile",
              to: "/settings/profile",
            },
            {
              icon: "landmark",
              label: "Bank Accounts",
              to: "/settings/bank",
            },
            {
              icon: "mail-question",
              label: "Notifications",
              to: "/settings/notifications",
            },
            {
              icon: "cog" as IconName,
              label: "Development",
              to: "/settings/development",
              visible: env.VITE_ENVIRONMENT !== "production",
            },
          ]}
        />
      }
    >
      <div className="flex flex-col p-6">
        <Suspense
          fallback={
            <div className="px-6">
              <SheetSkeleton />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
    </Page>
  );
}
